import { z } from 'zod';

export const ReportSettings = z.object({
  tax1098: z.boolean().prefault(true),
});
export type ReportSettings = z.infer<typeof ReportSettings>;
